import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { addToLocalCart } from "../services/CartServices";
import toast from "react-hot-toast";

const ProductDetail = () => {
  const { id } = useParams();
  const location = useLocation();
  const [item, setItem] = useState(null);
  const navigate = useNavigate();

  // Determine if this is a product or a gift based on the URL
  const isGift = location.pathname.startsWith("/gifts");

 useEffect(() => {
  const fetchItem = async () => {
    try {
      const token = localStorage.getItem("token");
      const url = isGift
        ? `${process.env.REACT_APP_API_URL}/gifts/id/${id}`
        : `${process.env.REACT_APP_API_URL}/products/${id}`;
      const res = await axios.get(
        url,
        token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
      );
      setItem(res.data);
    } catch (err) {
      console.error("Error fetching item:", err);
    }
  };
  fetchItem();
}, [id, isGift]);

  if (!item) return <p className="text-center mt-5">Loading...</p>;

  // Normalize fields for both product and gift
  const name = item.name;
  const description = item.description;
  const price = item.price ?? item.basePrice;
  const image = item.image || item.imageUrl || "/default.jpg";

  const handleAddToCart = () => {
  const payload = isGift
    ? {
        type: "GIFT",
        giftProductId: item.id,
        quantity: 1,
        name,
        price,
        image,
      }
    : {
        type: "PRODUCT",
        productId: item.id,
        quantity: 1,
        name,
        price,
        image,
      };
  addToLocalCart(payload);
  toast.success(`${name} added to cart!`);
  navigate("/cart");
};
  return (
    <div className="container py-5">
      <div className="row">
        <div className="col-md-6">
          <img
            src={image}
            alt={name}
            className="img-fluid rounded shadow"
          />
        </div>
        <div className="col-md-6">
          <h2>{name}</h2>
          <p>{description}</p>
          <h4>₹{price}</h4>
          <button className="btn btn-success mt-3" onClick={handleAddToCart}>
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;